const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Moment } from './Moment';
import * as utils from "./utils"
import { Account } from './Account';

export enum filterTypes {
  Edition = 1, Moment = 2
}

export class MomentOfferedStat extends Moment {
  public numActiveOffers: number = null         // always globally
  public numOffersLastXDays: number = null      // either globally or for a specific bidder
  public highestOfferPrice: number = null
  public highestOfferBuyerAddress: string = null
  public highestOfferBuyerUsername: string = null
  public highestOfferBuyerImageURL: string = null
  public isEditionOffer: boolean = null

  public salePriceInLastXDays: number = null
  public lowAskForEdition: number = null
  public spread: number = null        // highestOfferPrice - min(lowestSalePriceInLastXDays, lowAskForEdition)

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  // TODO: add more fields here for the MomentOfferedStat class
  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  // client only
  public generateKey(): string {
    return this.setID?.toString() + "/" + this.playID?.toString() + "/" + this.subeditionID?.toString() + "/" + this.serialNumber?.toString()
  }

  // because we have different columns for different filters
  public showNumRecentOffers = false
  public showNumActiveOffers = false
  public showSpread = false
  public showLowAsk = false
  public showRecentSale = false
  public showFMV = false

  public setForMostActiveEditions() {
    this.showNumRecentOffers = true
    this.showLowAsk = true
    // this.showRecentSale = true
    this.showFMV = true
  }
  
  public setForMostActiveMoments() {
    this.showNumRecentOffers = true
    this.showFMV = true
  }

  public setForLargestSpreadEditions() {
    this.showNumActiveOffers = true
    this.showSpread = true
    this.showLowAsk = true
    this.showRecentSale = true
  }

}

(async () => {
})();
